import WithRender from "../../templates/containers/pageOptionAttributesContainer.html";
import { mapGetters } from "vuex";

export default WithRender({
  computed: {
    ...mapGetters(["getActiveProductPageOptions"]),

    getProductPageOptionValues: function () {
      if (this.getActiveProductPageOptions[this.code]) {
        return this.getActiveProductPageOptions[this.code].values;
      }
      return [];
    },

    isRange: function () {
      return this.getActiveProductPageOptions[this.code].isRange;
    },

    getRangeData: function () {
      return this.getActiveProductPageOptions[this.code];
    }
  },
  props: ["propsData", "code", "hideContainer"]
});
